import { useTheme } from 'contexts'
import React from 'react'
import { StyleSheet } from 'react-native'

import { CoachOnboardingPrompt } from 'pages/CoachOnboarding/subcomponents/CoachOnboardingPrompt'

import { Box } from 'widgets/Box'
import { Button } from 'widgets/Button'
import { TextInput } from 'widgets/TextInput'

import { ThemeColor } from 'utils/themes/types'

type NameInputProps = {
  input?: string | null | undefined
  setInput?: (text: string | null | undefined) => void
  promptTitle?: string
  promptSubtitle?: string
  inputPlaceholder?: string
  textColor?: ThemeColor
  onNext?: () => void
}

export const NameInput = ({
  input,
  setInput,
  promptTitle,
  promptSubtitle,
  inputPlaceholder,
  textColor,
  onNext,
}: NameInputProps) => {
  const theme = useTheme()

  const computedStyles = StyleSheet.create({
    textInput: {
      backgroundColor: theme.colors.greyLight,
      borderRadius: 10,
      color: theme.colors.v2black,
    },
    button: {
      backgroundColor: theme.colors.v2black,
      borderRadius: 10,
      marginTop: 12,
    },
  })

  return (
    <Box flex={1} testID='NameInputContainer' padding='lg' backgroundColor='transparent'>
      <CoachOnboardingPrompt color={textColor} title={promptTitle} subtitle={promptSubtitle} />
      <Box testID='InputContainer' margin={{ top: 64 }}>
        <TextInput
          placeholder={inputPlaceholder}
          placeholderTextColor={theme.colors.greyDark}
          selectionColor='v2primary'
          style={computedStyles.textInput}
          onChange={() => setInput}
          value={input}
        />
        {onNext && (
          <Button
            type='v2black'
            title='Next'
            titleColor='white'
            style={computedStyles.button}
            onPress={onNext}
          />
        )}
      </Box>
    </Box>
  )
}
